import PersonalLoanInterestRateLayout from '../../views/interestRate/personalLoanInterestRate/Index'
import PersonalLoanInterestRateList from '../../views/interestRate/personalLoanInterestRate/List'
import PersonalLoanInterestRateEdit from '../../views/interestRate/personalLoanInterestRate/Edit'
import PersonalLoanInterestRateCreate from '../../views/interestRate/personalLoanInterestRate/Create'
import PersonalLoanInterestRateShow from '../../views/interestRate/personalLoanInterestRate/Show'
import Permissions from '@/permissions'

export const personalInterestRateRouters = {
  path: 'personal-interest-rate',
  component: PersonalLoanInterestRateLayout,
  redirect: '',
  meta: {
    permissions: [Permissions.backend.interestRate.personal.manage],
    groups: 'personal-interest-rate'
  },
  children: [
    {
      path: '',
      name: 'PersonalLoanInterestRateList',
      component: PersonalLoanInterestRateList,
      meta: {
        permissions: [Permissions.backend.interestRate.personal.list],
        groups: 'personal-interest-rate',
        breadcrumb: [
          {
            name_en: 'Interest Rate',
            name_km: 'អត្រាការប្រាក់'
          },
          {
            name_en: 'Personal Interest Rate',
            name_km: 'អត្រាការប្រាក់កម្ចីប្រចាំខែ'
          },
          {
            name_en: 'List',
            name_km: 'បញ្ជី'
          }
        ]
      }
    },
    {
      path: 'edit/:id',
      name: 'PersonalLoanInterestRateEdit',
      component: PersonalLoanInterestRateEdit,
      meta: {
        permissions: [Permissions.backend.interestRate.personal.edit],
        groups: 'personal-interest-rate',
        breadcrumb: [
          {
            name_en: 'Interest Rate',
            name_km: 'អត្រាការប្រាក់'
          },
          {
            name_en: 'Personal Interest Rate',
            name_km: 'អត្រាការប្រាក់កម្ចីប្រចាំខែ'
          },
          {
            name_en: 'Edit',
            name_km: 'កែសម្រួល'
          }
        ]
      }
    },
    {
      path: 'create',
      name: 'PersonalLoanInterestRateCreate',
      component: PersonalLoanInterestRateCreate,
      meta: {
        permissions: [Permissions.backend.interestRate.personal.store],
        groups: 'personal-interest-rate',
        breadcrumb: [
          {
            name_en: 'Interest Rate',
            name_km: 'អត្រាការប្រាក់'
          },
          {
            name_en: 'Personal Interest Rate',
            name_km: 'អត្រាការប្រាក់កម្ចីប្រចាំខែ'
          },
          {
            name_en: 'Create',
            name_km: 'បង្កើត'
          }
        ]
      }
    },
    {
      path: 'show/:id',
      name: 'PersonalLoanInterestRateShow',
      component: PersonalLoanInterestRateShow,
      meta: {
        permissions: [Permissions.backend.interestRate.personal.show],
        groups: 'personal-interest-rate',
        breadcrumb: [
          {
            name_en: 'Interest Rate',
            name_km: 'អត្រាការប្រាក់'
          },
          {
            name_en: 'Personal Interest Rate',
            name_km: 'អត្រាការប្រាក់កម្ចីប្រចាំខែ'
          },
          {
            name_en: 'Show',
            name_km: 'មើល'
          }
        ]
      }
    }
  ]
}
